// extracted by mini-css-extract-plugin
module.exports = {"audios":"style_audios__2cZyj","audio":"style_audio___07KZ","delete_button":"style_delete_button__5vhZN"};